import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ComboBoxField = _resolveComponent("ComboBoxField")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_FileUploadField = _resolveComponent("FileUploadField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref: "frmMain",
    "lazy-validation": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.skillModel && _ctx.skillModel.SkillId ? "Edit Technical Skills" : "Add Technical Skills "), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoBox, { title: "Add your technical skills here. If you dont see a skill listed, you can submit it manually" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ComboBoxField, {
                          readonly: _ctx.isHiringmanager,
                          rules: [_ctx.rules.required],
                          id: "skill",
                          label: "Skill",
                          placeholder: "Start Typing to Search ...",
                          items: _ctx.skillList,
                          showRequired: "",
                          outlined: "",
                          dense: "",
                          "item-title": "Text",
                          "item-value": "id",
                          "closable-chips": "",
                          modelValue: _ctx.skill.SkillId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.skill.SkillId) = $event)),
                          returnObject: false
                        }, null, 8, ["readonly", "rules", "items", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12 pb-0" }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Skill Level", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                          readonly: _ctx.isHiringmanager,
                          modelValue: _ctx.skill.Level,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.skill.Level) = $event)),
                          column: "",
                          rules: [_ctx.rules.required]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Basic",
                              value: "Basic"
                            }),
                            _createVNode(_component_v_radio, {
                              label: "Intermediate",
                              value: "Intermediate"
                            }),
                            _createVNode(_component_v_radio, {
                              label: "Advanced",
                              value: "Advanced"
                            })
                          ]),
                          _: 1
                        }, 8, ["readonly", "modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_NumberField, {
                          readonly: _ctx.isHiringmanager,
                          outlined: "",
                          dense: "",
                          label: "Years of Experience",
                          modelValue: _ctx.skill.TotalExperienceYears,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.skill.TotalExperienceYears) = $event)),
                          rules: [_ctx.rules.required, _ctx.rules.minNumber(0)],
                          min: "0"
                        }, null, 8, ["readonly", "modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FileUploadField, {
                          modelValue: _ctx.currentFile,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentFile) = $event)),
                          readonly: _ctx.isHiringmanager,
                          onChange: _ctx.fileChanged,
                          class: "mr-3",
                          accept: ".pdf,.doc,.docx,.png,.jpg",
                          dense: "",
                          "small-chips": "",
                          "show-size": _ctx.showSize,
                          outlined: "",
                          "prepend-icon": "",
                          label: "Your Certificate"
                        }, null, 8, ["modelValue", "readonly", "onChange", "show-size"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      disabled: _ctx.loading,
                      class: "secondary_btn",
                      onClick: _ctx.cancel
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "primary_btn",
                      loading: _ctx.loading,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveSkill())),
                      "prepend-icon": "mdi-check"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Save")
                      ])),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}